import { Card } from "reactstrap";
import Overtime from "../components/Overtime";
import { FiltersProvider } from "../filtersContext";
import { DateFiltersProvider } from "../hooks/useDateFilters";

function Overtimes() {
    return (
        <Card className="px-0 m-0 h-100 position-static">
            <FiltersProvider
                sessionKey="TIMESHEET_OVERTIMES"
                initialValue={[
                    {
                        method: "contains",
                        name: "employeeNumber",
                        value: "",
                    }
                ]}
            >
                <DateFiltersProvider>
                    <Overtime />
                </DateFiltersProvider>
            </FiltersProvider>
        </Card>
    );
}

export default Overtimes;
